import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputMultiChoiceAtLeatOneErrorMessage = (
  <Trans>
    Vous devez au moins séletionner une option dans ce champs
  </Trans>
);
